import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core';
import frameSrc from './assets/Mockup.png';
import frameHeadSrc from './assets/cam.png';
import Icon from "storybookComponents/Icon"
import "./index.css"

const styles = {
  container: {
    width: 380,
    position: 'relative',
    "& img": {
      width: "100%",

    },
    "& .frameHead": {
      position: "absolute",
      left: 0,
      right: 0,
      margin: "auto",
      width: 200,
      top: 16,
      zIndex: 2
    },
    "& iframe": {
      border: "none",
      borderRadius: 33,
      overflow: "hidden",
      width: "100%"
    },

  },
  mainPreviewContainer: {
    display: "flex",
  },
  contentFrame: {
    top: 26,
    left: 29,
    right: 26,
    bottom: 28,
    background: "white",
    borderRadius: 32,
    // width: "calc(100% - 54px)",
    // height: "calc(100% - 63px)",
    zIndex: 1,
    position: "absolute",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  smsView: {
    alignItems: "flex-end",
    display: "flex"
  },
  smsViewIframe: {
    borderRadius: "0 !important;",
    marginBottom: 20
  },
  arrowIcon: {
    // padding: 10,
    width: 80,
    //height: "100vh",
    cursor: "pointer",
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    paddingTop: 400,
    "&&:hover": {
      background: "#f2fbfe",
      color: "#26BBED !important"
    },
    "&&icon": {
      fontSize: "40px !important"
    }
  },
  arrowIconNull: {
    width: 40,
    padding: 10,
    //height: "100vh",
    display: "flex",
    alignItems: "center",
  }

}

class MobilePreview extends React.PureComponent {

  state = {
    index: 0,
    extrenalLink: false,
    html: this.props.html
  }

  prevView = () => {
    this.setState(p => ({ index: p.index - 1 }));
  }

  nextView = () => {
    this.setState(p => ({ index: p.index + 1 }));
  }

  componentDidMount() {
    const {
      id,
      smsView,
      extraMargin,
      customHeight,
      scrollToBottom,
    } = this.props;

    const frame = document.getElementById(id + "hylyIframe");
    if (!frame) return;


    frame.onload = function () {
      try {
        if (customHeight) return frame.style.height = customHeight + "px";
        let height = (frame.contentWindow.document.body.scrollHeight + (smsView ? 20 : extraMargin || 0));
        frame.style.minHeight = "700px";
        frame.style.height = height < 700 && !smsView ? "700px" : height + 'px';
        if (extraMargin)
          frame.parentNode.scrollTo(extraMargin, 100);
        if (scrollToBottom)
          frame.parentNode.scrollTop = frame.parentNode.scrollHeight;
      }
      catch (error) {
        frame.style.minHeight = "700px";
        frame.style.height = "auto";
        // this.setState({ extrenalLink: false })
      }
    }
  }

  updateHtml = (html) => {
    this.setState({ html })
  }

  render() {
    const {
      classes, id,
      smsView,
      mainBg,
      height,
      width,
    } = this.props;

    const { index, extrenalLink, html } = this.state;

    return (
      <div className={classes.mainPreviewContainer}>
        {
          Array.isArray(html) ? index > 0 ?
            <div className={classes.arrowIcon} onClick={this.prevView}>
              <Icon type="icon-left-arrow" />
            </div> :
            <div className={classes.arrowIconNull}>
            </div> : null
        }
        <div className={classes.container} style={{ height: height || "auto", width: width || 380 }}>
          <img src={frameSrc} alt="frame" style={{ maxHeight: "100%", maxWidth: "100%" }} />
          <img src={frameHeadSrc} className="frameHead" alt="frameHeadSrc" style={{ maxWidth: "100%" }} />
          <div style={{ background: mainBg || "white" }} id={"hyly-preview-mobile"} className={`${classes.contentFrame} ${!extrenalLink && smsView && classes.smsView}`}>
            <iframe id={id + "hylyIframe"} srcDoc={Array.isArray(html) ? html[index] : html} title="content" scrolling="no" className={`hyly-mobilepreview  ${smsView ? classes.smsViewIframe : ""}`} />
          </div>
        </div>
        {
          Array.isArray(html) ? index < html.length - 1 ?
            <div className={classes.arrowIcon} onClick={this.nextView}>
              <Icon type="icon-right-arrow" />
            </div> :
            <div className={classes.arrowIconNull}>
            </div>
            : null
        }
      </div>
    );
  }
}

MobilePreview.propTypes = {
  html: PropTypes.string,
};

MobilePreview.defaultProps = {
  html: '<div>Hello World</div>',
};

export default withStyles(styles)(MobilePreview);
